var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),title = locals_.title,content = locals_.content;
var jade_indent = [];
buf.push("\n<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">" + (jade.escape((jade_interp = title) == null ? '' : jade_interp)) + "</div>\n  <div class=\"panel-body\">");
if (typeof(content) != 'object')
{
buf.push("\n    <pre>" + (jade.escape((jade_interp = content) == null ? '' : jade_interp)) + "</pre>");
}
else if (Array.isArray(content))
{
buf.push("\n    <table class=\"table table-striped table-bordered\">\n      <tbody>");
// iterate content
;(function(){
  var $$obj = content;
  if ('number' == typeof $$obj.length) {

    for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
      var item = $$obj[idx];

if (typeof(item) == 'string')
{
buf.push("\n        <tr>\n          <td>" + (jade.escape((jade_interp = item) == null ? '' : jade_interp)) + "</td>\n        </tr>");
}
else
{
buf.push("\n        <tr>");
// iterate item
;(function(){
  var $$obj = item;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var value = $$obj[key];

buf.push("\n          <td>" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "</td>");
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      var value = $$obj[key];

buf.push("\n          <td>" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "</td>");
    }

  }
}).call(this);

buf.push("\n        </tr>");
}
    }

  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;      var item = $$obj[idx];

if (typeof(item) == 'string')
{
buf.push("\n        <tr>\n          <td>" + (jade.escape((jade_interp = item) == null ? '' : jade_interp)) + "</td>\n        </tr>");
}
else
{
buf.push("\n        <tr>");
// iterate item
;(function(){
  var $$obj = item;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var value = $$obj[key];

buf.push("\n          <td>" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "</td>");
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      var value = $$obj[key];

buf.push("\n          <td>" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "</td>");
    }

  }
}).call(this);

buf.push("\n        </tr>");
}
    }

  }
}).call(this);

buf.push("\n      </tbody>\n    </table>");
}
else
{
// iterate content
;(function(){
  var $$obj = content;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var value = $$obj[key];

buf.push("\n    <div class=\"row\">\n      <label class=\"field-name col-lg-5\">" + (jade.escape((jade_interp = key) == null ? '' : jade_interp)) + ":</label>\n      <div class=\"field-value col-lg-7\">" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "</div>\n    </div>");
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      var value = $$obj[key];

buf.push("\n    <div class=\"row\">\n      <label class=\"field-name col-lg-5\">" + (jade.escape((jade_interp = key) == null ? '' : jade_interp)) + ":</label>\n      <div class=\"field-value col-lg-7\">" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "</div>\n    </div>");
    }

  }
}).call(this);

}
buf.push("\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}